import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store";

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/ip-apply',
    name: 'IpApply',
    component: () => import('../views/IpApply.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue')
  },
  {
    path: '/front',
    name: 'Front',
    component: () => import('../views/front/Front'),
    children: [
      {
        path: 'home',
        name: 'FrontHome',
        component: () => import('../views/front/Home.vue')
      },
      {
        path: 'item1',
        name: 'Item1',
        component: () => import('../views/front/Item1.vue')
      },
      {
        path: 'person',
        name: 'FrontPerson',
        component: () => import('../views/front/Person')
      },
      {
        path: 'password',
        name: 'FrontPassword',
        component: () => import('../views/front/Password')
      },
      {
        path: 'video',
        name: 'Video',
        component: () => import('../views/front/Video')
      },
      {
        path: 'videoDetail',
        name: 'VideoDetail',
        component: () => import('../views/front/VideoDetail')
      },
      {
        path: 'article',
        name: 'FrontArticle',
        component: () => import('../views/front/Article')
      },
      {
        path: 'articleDetail',
        name: 'ArticleDetail',
        component: () => import('../views/front/ArticleDetail')
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 提供一个重置路由的方法
export const resetRouter = () => {
  router.matcher = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
  })
}

function setChildrenRouter(menus,manageRoute){
  menus.forEach(item => {
    if (item.path) {  // 当且仅当path不为空的时候才去设置路由
      let itemMenu = { path: item.path.replace("/", ""), name: item.name, component: () => import('../views/' + item.pagePath + '.vue')}
      manageRoute.children.push(itemMenu)
    } else if(item.children.length) {
      setChildrenRouter(item.children,manageRoute)
    }
  })
}

export const appendSystemMenus = (menus) => {
  const user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : {}
  const role = user.role
  if (role !== 'APP_ADMIN' && role !== 'ROLE_ADMIN') {
    return menus
  }
  const exists = menus.some(item => item.path === '/IpControl' || item.pagePath === 'IpControl')
  if (!exists) {
    menus.push({
      id: 90501,
      name: "登录IP管控",
      path: "/IpControl",
      icon: "el-icon-lock",
      description: null,
      children: [],
      pid: null,
      pagePath: "IpControl",
      sortNum: "90501"
    })
  }
  return menus
}


// 注意：刷新页面会导致页面路由重置
export const setRoutes = () => {
  const storeMenus = localStorage.getItem("menus");
  if (storeMenus) {

    // 获取当前的路由对象名称数组
    const currentRouteNames = router.getRoutes().map(v => v.name)
    if (!currentRouteNames.includes('Manage')) {
      // 拼装动态路由
      const manageRoute = { path: '/', name: 'Manage', component: () => import('../views/Manage.vue'), redirect: "/home", children: [
          { path: 'person', name: '个人信息', component: () => import('../views/Person.vue')},
          { path: 'password', name: '修改密码', component: () => import('../views/Password.vue')}
        ] }
      const menus = appendSystemMenus(JSON.parse(storeMenus))
      setChildrenRouter(menus,manageRoute)
      // 动态添加到现在的路由对象中去
      router.addRoute(manageRoute)
    }

  }
}

// 重置我就再set一次路由
setRoutes()


router.beforeEach((to, from, next) => {
  localStorage.setItem("currentPathName", to.name)  // 设置当前的路由名称
  store.commit("setPath")

  console.log("currentPathName: " , to)
  // 未找到路由的情况
  if (!to.matched.length) {
    const storeMenus = localStorage.getItem("menus")
    if (storeMenus) {
      next("/404")
    } else {
      // 跳回登录页面
      //next("/front/home")
      next("login")
    }
  }
  // 其他的情况都放行
  next()
  if (!to.path.includes("front") && !to.path.includes("login")) {
    config.setTitle("天盛员工管理系统")
  }

})

export default router
